import { Controller } from 'stimulus';

// A Person window list (tasks/popup/_people_list): ticking a row marks it,
// the search narrows the rows by name, and the This Person list's "Usually"
// line can tick the usual person (or press No One Needed). Nothing saves
// here: the ticked boxes post with the window's Save.
export default class extends Controller {
  static targets = ['row', 'none', 'usual']

  tick(event) {
    const row = event.currentTarget.closest('[data-target~="people-list.row"]');
    if (row) row.classList.toggle('is-on', event.currentTarget.checked);
    this.syncUsual();
  }

  filter(event) {
    const q = event.currentTarget.value.trim().toLowerCase();
    let shown = 0;
    this.rowTargets.forEach((row) => {
      row.hidden = !!q && row.dataset.search.indexOf(q) < 0;
      if (!row.hidden) shown += 1;
    });
    if (this.hasNoneTarget) this.noneTarget.hidden = shown > 0;
  }

  // "Usually Amy Wong · Use It": ticks them; "Usually No One Needed" presses
  // that toggle (task-scheduling shows its panel)
  useUsual(event) {
    event.preventDefault();
    const value = event.currentTarget.dataset.value;
    if (value === 'none') {
      const scope = this.element.closest('[data-controller~="task-scheduling"]') || document;
      const button = scope.querySelector('button[data-group="person"][data-value="none"]');
      if (button) button.click();
      return;
    }
    const box = this.element.querySelector(`input[type="checkbox"][value="${value}"]`);
    if (!box || box.disabled) return;
    box.checked = true;
    box.closest('[data-target~="people-list.row"]').classList.add('is-on');
    this.syncUsual();
  }

  syncUsual() {
    if (!this.hasUsualTarget) return;
    const value = this.usualTarget.dataset.value;
    const box = this.element.querySelector(`input[type="checkbox"][value="${value}"]`);
    this.usualTarget.hidden = !!box && box.checked;
  }
}
